import { Box, Typography } from "@mui/material";

export default function LegalLayout({
  title,
  text,
}: {
  title: string;
  text: string;
}) {
  return (
    <Box sx={{ maxWidth: 900, mx: "auto", p: 4 }}>
      <Typography variant="h4" fontWeight="bold" mb={3}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-line", lineHeight: 1.8 }}>
        {text}
      </Typography>
    </Box>
  );
}
